import React, { ReactNode, createContext, useContext, useEffect, useState } from 'react';
import { getMyData } from '../../../services/MyData.service';

interface User {
  bairro: string | null;
  celular: string | null;
  cep: string | null;
  cidadeId: number | null;
  cidadeNome: string | null;
  cpf: string | null;
  dataNascimento: number | null;
  email: string;
  endereco: string | null;
  id: number | null;
  mostrarTelefone: boolean | null;
  nome: string;
  sexo?: string | null;
  telefone: string | null;
  ufId: string | null;
  ufNome: string | null;
}

interface UserContextInterface {
  userData: User | undefined;
}

interface UserContextProviderProps {
  children: ReactNode;
}

export const UserContext = createContext<UserContextInterface | undefined>(undefined);

export function UserContextProvider({ children }: UserContextProviderProps): JSX.Element {
  const [userData, setUserData] = useState<User | undefined>(undefined);

  useEffect(() => {
    getMyData()
      .then(data => setUserData(data))
      .catch(error => console.log(error));
  }, []);

  return <UserContext.Provider value={{ userData }}>{children}</UserContext.Provider>;
}

export function useUserContext(): UserContextInterface {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error('User is not available');
  }

  return context;
}
